<template>
  <div class='EnbPreferenceGeral'>
    <div class="cont">
      <div class="left">
        <select-logo/>
        <pref-comp
        comp="nave"
        simple
        label="Topo(Navegação)"
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'nave', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'nave', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'nave', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'nave', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'nave', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'nave', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'nave', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        comp="navepainel"
        simple
        label="Navegação painel"
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'navepainel', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        comp="rodape"
        simple
        label="Rodapé"
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'rodape', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        v-if="Empresa.modelo !== 'Modelo 03'"
        comp="cart"
        label="Carrinho"
        simple
        icone
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'cart', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'cart', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'cart', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'cart', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'cart', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'cart', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'cart', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        comp="spinner"
        spinner
        label="Spinner(animação de carregamento)"
        @update:corSpinner="newValue => UpdatePrefComp({ comp: 'spinner', prop: 'cor', value: newValue })"
        />
        <pref-comp
        v-if="Empresa.modelo === 'Modelo 03'"
        label="Whatsapp"
        inputWhatsapp
        />
        <div style="height: 5%;"></div>
      </div>
      <div class="right">
        <select-font/>
        <pref-comp
        comp="btn"
        simple
        :label="Empresa.modelo !== 'Modelo 03' ? 'Botões Loja' : 'Botões Site'"
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'btn', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'btn', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'btn', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'btn', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'btn', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'btn', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'btn', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        comp="produto"
        simple
        :label="Empresa.modelo === 'Modelo 03' ? 'Imóvel no Site' : 'Produto'"
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'produto', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'produto', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'produto', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'produto', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'produto', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'produto', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'produto', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        v-if="Empresa.modelo !== 'Modelo 03'"
        comp="btnProduto"
        simple
        label="Botão produto"
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'corBackground', value: newValue })"
        @update:corFont="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'corFont', value: newValue })"
        @update:font="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'font', value: newValue })"
        @update:fontStyle="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'fontStyle', value: newValue })"
        @update:fontBold="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'fontBold', value: newValue })"
        @update:textDecoration="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'textDecoration', value: newValue })"
        @update:fontHeight="newValue => UpdatePrefComp({ comp: 'btnProduto', prop: 'fontHeight', value: newValue })"
        />
        <pref-comp
        :label="Empresa.modelo !== 'Modelo 03' ? 'Cor de fundo Loja' : 'Cor de fundo Site'"
        comp="lojaCorFundo"
        lojaCorFundo
        @update:corBackground="newValue => UpdatePrefComp({ comp: 'lojaCorFundo', prop: 'corBackground', value: newValue })"
        />
        <pref-comp
        :label="Empresa.modelo !== 'Modelo 03' ? 'Cor da fonte Loja' : 'Cor da fonte Site'"
        comp="lojaCorFonte"
        lojaCorFonte
        @update:color="newValue => UpdatePrefComp({ comp: 'lojaCorFonte', prop: 'color', value: newValue })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectLogo from './SelectLogo'
import SelectFont from './SelectFont'
import PrefComp from './PrefComp'
export default {
  name: 'EnbPreferenceGeral',
  components: { SelectLogo, SelectFont, PrefComp },
  computed: {
    ...mapGetters(['Themes', 'Empresa'])
  },
  methods: {
    ...mapActions(['ChangeTheme', 'UpdatePrefComp', '_UpdatePreference', '_UpdateMapsNets'])
  }
}
</script>

<style scoped>
.cont {
  display: flex;
}

.left {
  width: 50%;
  padding: 1%;
}

.right {
  width: 50%;
  padding: 1%;
}
</style>
